module.exports = __webpack_public_path__ + "static/img/tribunalsupremojusticia.d3299d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tribunalsupremojusticia.png
// module id = sm7g
// module chunks = 9